'use client';

import { useEffect, useRef } from 'react';

type GeneralConditionsContentProps = {
  generalConditions: string;
  title?: string;
};

export const GeneralConditionsContent = ({
  generalConditions,
  title = 'Condições Gerais',
}: GeneralConditionsContentProps) => {
  const printRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hash) {
      const hash = window.location.hash.substring(1);
      const element = document.getElementById(hash);

      if (element && typeof element.scrollIntoView === 'function') {
        const timeoutId = setTimeout(() => {
          try {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch {
            window.scrollTo(0, element.offsetTop);
          }
        }, 100);

        return () => clearTimeout(timeoutId);
      }
    }
  }, []);

  return (
    <div className="flex flex-grow flex-col gap-4 p-2">
      <div
        ref={printRef}
        className="prose prose-sm max-w-none text-foreground/90 overflow-y-auto"
      >
        <h1 className="text-xl font-bold mb-4 text-foreground">{title}</h1>
        <div
          id="condicoes-gerais"
          className="text-sm leading-relaxed scroll-mt-4"
          dangerouslySetInnerHTML={{ __html: generalConditions }}
        />
      </div>
    </div>
  );
};
